import { Injectable } from '@angular/core'
import {
  ModalResponse,
  NgModalServiceInterface,
} from '../../models/modal.model'
import { NgNotificationServiceInterface } from '../../models/notification.model'
import {
  TagModalCode,
  TagNotificationCode,
  parseTagModal,
  parseTagNotification,
} from './libs/tag-notification.lib'
import { Tag } from './models/tag.entity'

@Injectable({
  providedIn: 'root',
})
export class TagsRepository {
  constructor(
    private ngModalService?: NgModalServiceInterface,
    private ngNotificationService?: NgNotificationServiceInterface,
  ) {}

  notify(options: { code?: TagNotificationCode; message?: string }): void {
    this.ngNotificationService?.show(
      options.message
        ? { title: 'Error', message: options.message, color: 'error' }
        : parseTagNotification(options.code),
    )
  }

  async alert(code: TagModalCode, tag?: Tag): Promise<ModalResponse> {
    const settings = parseTagModal(code, tag)
    if (!this.ngModalService || !settings) {
      return 'closed'
    }
    return await this.ngModalService.showDialog(settings)
  }
}
